import React, { useState, useRef, useEffect } from "react";

// Ícono de lupa, copiado local (SVG simple) para no acoplar este módulo al de Auditoria.
const IconoBuscar = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.35-4.35" />
    </svg>
);

// Selector múltiple (checkboxes): botón resumen + panel con buscador,
// checkboxes y "Limpiar". `open`/`onToggle`: panel controlado por el padre
// (si no se mandan, usa estado propio). `flotante`: panel en `position: absolute`.
export const FiltroMultiSelect = ({
    label,
    options = [],
    selected = [],
    onChange,
    open,
    onToggle,
    flotante = false,
}) => {
    const [openInterno, setOpenInterno] = useState(false);
    const [busqueda, setBusqueda] = useState("");
    const buscadorRef = useRef(null);
    const controlado = open !== undefined;
    const abierto = controlado ? open : openInterno;

    // Limpia la búsqueda al cerrar, para que la próxima apertura muestre el catálogo completo.
    useEffect(() => {
        if (!abierto) setBusqueda("");
    }, [abierto]);

    // Enfoca el buscador al abrir el panel.
    useEffect(() => {
        if (abierto && buscadorRef.current) {
            const id = setTimeout(() => buscadorRef.current?.focus(), 50);
            return () => clearTimeout(id);
        }
    }, [abierto]);

    const opcionesFiltradas =
        busqueda.trim() === ""
            ? options
            : options.filter((o) =>
                  String(o.label ?? "").toLowerCase().includes(busqueda.trim().toLowerCase())
              );

    const seleccionados = options.filter((o) => selected.includes(o.value));
    const displayLabel =
        selected.length === 0
            ? "Todos"
            : selected.length <= 2
                ? seleccionados.map((o) => o.label).join(", ")
                : `${selected.length} seleccionados`;

    const toggleValue = (value) => {
        const yaEsta = selected.includes(value);
        onChange(yaEsta ? selected.filter((v) => v !== value) : [...selected, value]);
    };

    const alternarAbierto = () => {
        if (controlado) {
            if (typeof onToggle === "function") onToggle();
        } else {
            setOpenInterno((o) => !o);
        }
    };

    return (
        <div className="fms-field">
            <label className="fms-label">{label}</label>
            <button
                type="button"
                className="fms-boton"
                onClick={alternarAbierto}
            >
                <span className="fms-boton-texto" title={displayLabel}>
                    {displayLabel}
                </span>
                <span className="fms-flecha">▾</span>
            </button>
            {abierto && (
                <div className={`fms-panel${flotante ? " fms-panel--flotante" : ""}`}>
                    {options.length > 5 && (
                        <div className="fms-buscador">
                            <IconoBuscar />
                            <input
                                ref={buscadorRef}
                                type="text"
                                className="fms-buscador-input"
                                placeholder="Buscar..."
                                value={busqueda}
                                onChange={(e) => setBusqueda(e.target.value)}
                                onClick={(e) => e.stopPropagation()}
                            />
                            {busqueda && (
                                <button
                                    type="button"
                                    className="fms-buscador-limpiar"
                                    onClick={() => setBusqueda("")}
                                    tabIndex={-1}
                                >
                                    ×
                                </button>
                            )}
                        </div>
                    )}
                    <div className="fms-opciones-lista scroll">
                        {opcionesFiltradas.length === 0 ? (
                            <div className="fms-sin-resultados">
                                Sin resultados para "{busqueda}"
                            </div>
                        ) : (
                            opcionesFiltradas.map((o) => (
                                <label key={o.value} className="fms-opcion">
                                    <input
                                        type="checkbox"
                                        checked={selected.includes(o.value)}
                                        onChange={() => toggleValue(o.value)}
                                    />
                                    {o.label}
                                </label>
                            ))
                        )}
                    </div>
                    <button
                        type="button"
                        className="fms-limpiar"
                        onClick={() => onChange([])}
                    >
                        Limpiar (Todos)
                    </button>
                </div>
            )}
        </div>
    );
};
